import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "@/components/common/ScrollToTop";
import Home from "@/pages/Home";
import ServicePageF6 from "@/pages/interior/ServicePageF6";
import AboutKatrinaPage from "@/pages/interior/AboutKatrinaPage";
import ResourcesPage from "@/pages/interior/ResourcesPage";
import ResourceDetailPage from "@/pages/interior/ResourceDetailPage";
import ContactPage from "@/pages/interior/ContactPage";
import AdminPage from "@/pages/AdminPage";
import LandingIndex from "@/pages/LandingIndex";
import ConceptA from "@/pages/ConceptA";
import ConceptB from "@/pages/ConceptB";
import ConceptC from "@/pages/ConceptC";
import ConceptD from "@/pages/ConceptD";
import ConceptE from "@/pages/ConceptE";
import AboutPage from "@/pages/interior/AboutPage";
import PathwayPage from "@/pages/interior/PathwayPage";
import InsightsIndexPage from "@/pages/interior/InsightsIndexPage";
import PublicationPage from "@/pages/interior/PublicationPage";
import SpeakingPage from "@/pages/interior/SpeakingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Faith 1st Consulting — production site */}
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServicePageF6 />} />
          <Route path="/about-katrina" element={<AboutKatrinaPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/:slug" element={<ResourceDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />

          {/* Legacy concept archive */}
          <Route path="/concepts" element={<LandingIndex />} />
          <Route path="/concept-a" element={<ConceptA />} />
          <Route path="/concept-b" element={<ConceptB />} />
          <Route path="/concept-c" element={<ConceptC />} />
          <Route path="/concept-d" element={<ConceptD />} />
          <Route path="/concept-e" element={<ConceptE />} />
          <Route path="/concept-e/about" element={<AboutPage />} />
          <Route path="/concept-e/pathways/:slug" element={<PathwayPage />} />
          <Route path="/concept-e/insights" element={<InsightsIndexPage />} />
          <Route path="/concept-e/insights/:slug" element={<PublicationPage />} />
          <Route path="/concept-e/speaking" element={<SpeakingPage />} />

          {/* Retired Concept 6 preview routes → production site */}
          <Route path="/concept-f/*" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
